import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Grid } from "@mui/material";
// import signature from "../../../assets/signature.png";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import { authHttp } from "../../services/utility";
import { apisPath, paths } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";
import PrintIcon from "@mui/icons-material/Print";
import { decrypt, encrypt } from "../../../utils/encryptDecrypt";
// import { abledType } from "../../../utils/helpers";
import HeaderLogoImage from "../../../assets/pdf-logo.png";
import { abledType, appPrefix } from "../../../utils/helpers";
import "../../../styles/Layout/Admin_Styles/_CandidateInfoModal.scss";
import PersonalDetails from "./PersonalDetails";
import { useLocation, useNavigate } from "react-router-dom";
import Nationality from "../../../shared/FinalPreview/Nationality/Nationality";
import RequiredEligibility from "../../../shared/FinalPreview/RequiredEligibility/RequiredEligibility";
import CategoryDetails from "../../../shared/FinalPreview/CategoryDetails/CategoryDetails";
import AddressDetails from "../../../shared/FinalPreview/AddressDetails/AddressDetails";
import QualificationDetails from "../../../shared/FinalPreview/QualificationDetails/QualificationDetails";
import PrefentialQualDetails from "../../../shared/FinalPreview/PrefentialQualDetails/PrefentialQualDetails";
import OtherDetails from "../../../shared/FinalPreview/OtherDetails/OtherDetails";
import FeeDetails from "../../../shared/FinalPreview/FeeDetails/FeeDetails";
import Declaration from "../../../shared/FinalPreview/Declaration/Declaration";
import Footer from "../../../shared/FinalPreview/Footer/Footer";

export default function CandidateInfoModal(_props) {
  const { selectedId } = _props;

  const { state } = useLocation();
  const navigate = useNavigate();
  const [isFeeExempted, setIsFeeExempted] = useState(false);
  const [candidateData, setCandidateData] = useState({});
  const { setIsLoading, setAlertState } = useContext(AuthContext);
  const [claimedMsg, setClaimedMsg] = useState("");
  const className = 'candidate-info'

  useEffect(() => {
    if (state) {
      setIsLoading(true);
      authHttp
        .post(apisPath?.admin?.viewApplicationDetail, {
          application_no: state.replace(appPrefix, ""),
        })
        .then((res) => {
          // console.log()
          const idProofNo = res?.data?.data?.id_proof_no
            ? decrypt(res?.data?.data?.id_proof_no)
            : "";
          if (idProofNo) {
            let tempidProofNo = `${idProofNo.slice(0, 2)}`;
            for (let i = 0; i < idProofNo.length - 4; i++) {
              tempidProofNo += "X";
            }
            tempidProofNo += `${idProofNo.slice(idProofNo.length - 2)}`;
            tempidProofNo = encrypt(tempidProofNo);
            setCandidateData({
              ...res?.data?.data,
              id_proof_no: tempidProofNo,
            });
          } else {
            setCandidateData(res?.data?.data);
          }
          // console.log()
          setIsFeeExempted(parseInt(res?.data?.data?.exam_fee + res?.data?.data?.exam_service_charge) === 0);
          const tempType = abledType.find(
            (type) => type?.name === res?.data?.data?.differently_abled_type
          );
          let msg = "";
          msg = res?.data?.data?.category;
          msg +=
            Number(res?.data?.data?.is_differently_abled) === 1
              ? `/PH(${tempType?.short_code})`
              : "";
          msg +=
            Number(res?.data?.data?.is_exserviceman) === 1 &&
              Number(res?.data?.data?.exservicemen_availed_benefits) === 0
              ? "/Ex-Servicemen"
              : "";
          msg +=
            Number(res?.data?.data?.dff) === 1
              ? "/Dependent of Freedom Fighter (DFF)"
              : "";
          msg +=
            Number(
              res?.data?.data
                ?.permanent_resident_uttarakhand_covered_by_govt_order
            ) === 1
              ? "/Uttarakhand Orphan"
              : "";
          msg +=
            Number(res?.data?.data?.is_uttarakhand_female) === 1
              ? "/Uttarakhand Female"
              : "";
          setClaimedMsg(msg);
          // setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setAlertState((prev) => ({
            ...prev,
            open: true,
            title: err?.response?.data?.msg,
            btnTxt: "CLOSE",
            status: "fail",
            isSessionExpire: err?.response?.status === 401,
            sessionType: "admin",
          }));
        });
    } else {
      navigate(
        `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidates}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);

  const handlePrint = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.print(element);
    }
  };

  return (
    <Box className="candidate-info" id="candidate-data">
      <div className="candidate-info--grid">
        <Grid container>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className="print-logoNew">
              <div className="headerImg">
                <img src={HeaderLogoImage} alt="ExamImg" height="500px" />
              </div>
            </div>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className="candidate-info--head">
              <div className="candidate-info--header">
                <h2>
                  {candidateData?.name ? decrypt(candidateData?.name) : "-"}
                </h2>
              </div>
              <div className="candidate-info--button">
                <Button
                  className="print-btn"
                  onClick={() => handlePrint("candidate-data")}
                  startIcon={<PrintIcon />}
                >
                  Print
                </Button>
              </div>
            </div>

            <div className="candidate-info--form">
              <div className="candidate-info--personaldetails">
                <PersonalDetails
                  title="Personal Information"
                  isFinal={true}
                  candidateData={candidateData}
                />
              </div>

              <Nationality candidateData={candidateData} className={className} />

              <RequiredEligibility candidateData={candidateData} className={className} />

              <CategoryDetails candidateData={candidateData} className={className} claimedMsg={claimedMsg} />

              <AddressDetails candidateData={candidateData} className={className} />

              <QualificationDetails candidateData={candidateData} className={className} />

              <PrefentialQualDetails candidateData={candidateData} className={className} />

              <OtherDetails candidateData={candidateData} className={className} />

              <FeeDetails candidateData={candidateData} className={className} isFeeExempted={isFeeExempted} />

              <Declaration candidateData={candidateData} className={className} />

              <Footer candidateData={candidateData} className={className} />

            </div>
            <div className="candidate-info-dummy" />
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}
